import React from 'react';
import { Row, Select } from 'antd';
import PropTypes from 'prop-types';

export default function CobraPMASelector({
  onChange,
  disable,
  selected,
  options,
  type,
}) {
  return (
    <>
      <Row style={{ marginTop: 5 }}>
        Select {type} Field:
      </Row>
      <Row style={{ margin: '10px 0px' }}>
        <Select
          onChange={onChange}
          style={disable ? { pointerEvents: 'none', width: '100%' } : { width: '100%' }}
          dropdownMatchSelectWidth={false}
          value={selected}
          showSearch
          optionFilterProp="label"
          options={options}
        />
      </Row>
    </>
  );
}

CobraPMASelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  disable: PropTypes.bool,
  selected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  type: PropTypes.string.isRequired,
};

CobraPMASelector.defaultProps = {
  disable: false,
  selected: null,
};
